import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const ProviderPicker = defineAsyncComponent(() => import('@/js/comparisons/ProviderPicker.vue'));
const DominanceChart = defineAsyncComponent(() => import('@/js/global-charts/DominanceChart.vue'));

app.component('DominanceChart', DominanceChart);
app.component('ProviderPicker', ProviderPicker);

mountApp();
